exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renderArea[data-v-5f6219ba] p{margin:0}", ""]);

// exports
